import { createStore } from 'satcheljs';
import AssignOpenShiftsPollingStateSchema from './schema/AssignOpenShiftsPollingStateSchema';

const initialState: AssignOpenShiftsPollingStateSchema = {
    activeJob: undefined,
    showSuccessToast: false,
    showFailureToast: false,
    showCancelledToast: false,
    dismissResultToastsSignal: 0
};

const assignOpenShiftsPollingState = createStore<AssignOpenShiftsPollingStateSchema>(
    'assignOpenShiftsPollingState',
    initialState
);

export { assignOpenShiftsPollingState };
